import * as React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { SectionHeading } from 'pages/support-v2/support-form-v2.styled';

interface IErrorViewProps {
  message: string;
}

/**
 * Full content area view with error message.
 */

export const ErrorView = ({ message }: IErrorViewProps) => {
  useLogUserErrorMessage({ message });

  return (
    <Box style={styles.contentLoadingContainer}>
      <SectionHeading testID="error-message">{message}</SectionHeading>
    </Box>
  );
};

const styles = StyleSheet.create({
  contentLoadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
